import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input[noNumbers]'

})
export class NoNumbersDirective {

  constructor(private _el: ElementRef, private ngControl: NgControl) { }

  // @HostListener('input', ['$event']) onInputChange(event: any) {
  //   const initalValue = this._el.nativeElement.value;
  //   this._el.nativeElement.value = initalValue.replace(/[^0-9]*/g, '');
  //   if (initalValue !== this._el.nativeElement.value) {
  //     event.stopPropagation();
  //   }
  // }

  @HostListener('input', ['$event']) onInputChange(event: any) {
    var regex = new RegExp("^[0-9]*$");
    var str = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (regex.test(str)) {
      event.preventDefault();
      return false;
    }

    return true;
  }

  @HostListener('keypress', ['$event']) onKeypress(event: any) {
    var regex = new RegExp("^[0-9]*$");
    var str = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (regex.test(str)) {
      event.preventDefault();
      return false;
    }

    return true;
  }

  @HostListener('paste', ['$event']) onPaste(event: any) {
    let clipboardData = event.clipboardData;
    var regex = new RegExp(/[0-9]/g);
    let pastedText = clipboardData.getData('text');
    if (regex.test(pastedText)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

}
